export const __REGISTRATION_CONSTANTS__ = {
    REQUEST_TOKEN_TIMEOUT: 10000,
    MAX_RETRY_DELAY: 40000
} as const;
